import PropTypes from "prop-types";
import React from "react";

import { Transition } from "../../Transition";

const STROKE_LENGTH = 39;

export const Check = (props) => {
  const { className, custom, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <Transition {...getPathProps()} />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      style,
      viewBox: "0 0 32 32",
    };
  }
  function getPathProps() {
    const strokeDashoffset = !custom?.type || custom.type === "active" ? 0 : STROKE_LENGTH;

    return {
      animate: { strokeDashoffset },
      component: "path",
      componentProps: {
        d: "M2,14 L13,24 L29,7",
        fill: "none",
        strokeDasharray: STROKE_LENGTH,
        strokeWidth: "5",
      },
      initial: { strokeDashoffset },
    };
  }
};

Check.displayName = "CheckIcon";

Check.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /**
   * custom allows for component to implement styling for a specific characteristic. There is no obligation for a
   * component to implement the custom prop.
   */
  custom: PropTypes.object,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Check.defaultProps = {
  role: "img",
};
